export function getCountries() {
  return [{ id: "Angola", name: "Angola" }];
}

export function getProvinces() {
  return [
    { id: "Bengo", name: "Bengo" },
    { id: "Benguela", name: "Benguela" },
    { id: "Bié", name: "Bié" },
    { id: "Cabinda", name: "Cabinda" },
    { id: "Cuando-Cubango", name: "Cuando-Cubango" },
    { id: "Cuanza Norte", name: "Cuanza Norte" },
    { id: "Cuanza Sul", name: "Cuanza Sul" },
    { id: "Cunene", name: "Cunene" },
    { id: "Huambo", name: "Huambo" },
    { id: "Huíla", name: "Huíla" },
    { id: "Luanda", name: "Luanda" },
    { id: "Lunda Norte", name: "Lunda Norte" },
    { id: "Lunda Sul", name: "Lunda Sul" },
    { id: "Malanje", name: "Malanje" },
    { id: "Moxico", name: "Moxico" },
    { id: "Namibe", name: "Namibe" },
    { id: "Uíge", name: "Uíge" },
    { id: "Zaire", name: "Zaire" }
  ];
}
